import axios from "axios";
import authHeader from "./auth-header";
const { DateTime } = require("luxon");

const API_URL = "https://hexeverestfunctions.azurewebsites.net/api/";

class SpecialreportService {
  GetDailyReport01ByDate(date) {
    var luxonDate = DateTime.fromJSDate(date);
    var start = luxonDate.toISO().split("+")[0];

    return axios.get(API_URL + "GetDailyReport01ByDate?date=" + start, {
      headers: authHeader(),
    });
  }

  PostDailyReport01(data, date, i) {
    console.log("hic!!");
    console.log(date);
    var luxonDate = DateTime.fromJSDate(date);
    console.log(luxonDate.toISO());
    var start = luxonDate.toISO().split("T")[0];
    let element = {
      title: data.boldText,
      paragraph: data.note,
      titleProperties: i,
      userReportId: data.userReportId,
      reportDate: start,
      value1: data.employeeId,
      value2: data.statusId,
      isVisible: data.isVisible,
      isConfirmed: data.isConfirmed,
      string1: data.sRecursive,
    };
    console.log(element);

    return axios.post(API_URL + "PostDailyReport01", element, {
      headers: authHeader(),
    });
  }

  GetDailyReport02ByDate(date) {
    var luxonDate = DateTime.fromJSDate(date);
    var start = luxonDate.toISO().split("+")[0];

    return axios.get(API_URL + "GetDailyReport02ByDate?date=" + start, {
      headers: authHeader(),
    });
  }

  StadionRecalculateCameToWorkAndWriteToReportCommentByDate(date) {
    var luxonDate = DateTime.fromJSDate(date);
    var start = luxonDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "StadionRecalculateCameToWorkAndWriteToReportCommentByDate?date=" +
        start,
      {
        headers: authHeader(),
      }
    );
  }

  StadionRecalculateFakturnoAndWriteToReportCommentByDate(date) {
    var luxonDate = DateTime.fromJSDate(date);
    var start = luxonDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "StadionRecalculateFakturnoAndWriteToReportCommentByDate?date=" +
        start,
      {
        headers: authHeader(),
      }
    );
  }

  StadionRecalculatePrivateEventsAndWriteToReportCommentByDate(date) {
    var luxonDate = DateTime.fromJSDate(date);
    var start = luxonDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "StadionRecalculatePrivateEventsAndWriteToReportCommentByDate?date=" +
        start,
      {
        headers: authHeader(),
      }
    );
  }

  // PostDailyReport01WithDateAsString(data, date, i) {
  //   console.log("hic!!");
  //   var start = date.split("T")[0];
  //   let element = {
  //     title: data.boldText,
  //     paragraph: data.note,
  //     titleProperties: i,
  //     userReportId: data.userReportId,
  //     reportDate: start,
  //     value1: data.employeeId,
  //     isConfirmed: data.isConfirmed,
  //   };

  //   return axios.post(API_URL + "PostDailyReport01", element, {
  //     headers: authHeader(),
  //   });
  // }

  EditDailyReport01(data, date, i) {
    var luxonDate = DateTime.fromJSDate(date);
    var start = luxonDate.toISO().split("+")[0];
    console.log("BROJ 2");
    console.log(data);
    let element = {
      reportcommentId: data.reportcommentId,
      title: data.boldText,
      paragraph: data.note,
      titleProperties: i,
      userReportId: data.userReportId,
      reportDate: start,
      isConfirmed: data.isConfirmed,
      value1: data.employeeId,
      value2: data.statusId,
      string1: data.sRecursive,
    };

    return axios.put(API_URL + "EditDailyReport01", element, {
      headers: authHeader(),
    });
  }

  DeleteReport01(rc) {
    return axios.delete(API_URL + "DeleteReport01", {
      headers: authHeader(),
      data: rc,
    });
  }

  DeleteReport01ByValue1TitlePropertiesAndReportDate(
    value1,
    titleProperties,
    reportDate
  ) {
    var luxonDate = DateTime.fromJSDate(reportDate);
    var date = luxonDate.toISO().split("+")[0];

    console.log("vogi22");
    console.log(date);

    let reportToDelete = {
      value1: value1,
      titleProperties: titleProperties,
      reportDate: date,
    };
    return axios.delete(
      API_URL + "DeleteReport01ByValue1TitlePropertiesAndReportDate",
      {
        headers: authHeader(),
        data: reportToDelete,
      }
    );
  }
}

export default new SpecialreportService();
